export interface SubmitPharmReorderRequestItem {
  pharmacyLocation: string;
  patientId: number;
  enterpriseOrderId: string;
  items: PharmItems[];
  customerId: string;
  source: string;
}

export interface PharmItems {
  rxNumber: number;
  drugDescription: string;
  quantity: number;
}

export interface ApiSubmitPharmReorderRequest {
  pharmacyLocation: string;
  patientId: number;
  enterpriseOrderId: string;
  items: PharmItems[];
  customerId: string;
  source: string;
}

export const buildSubmitPharmReorderRequest = (
  pharmacyLocation: string,
  patientId: number,
  enterpriseOrderId: string,
  items: PharmItems[],
  customerId: string,
  source: string
): ApiSubmitPharmReorderRequest => ({
  pharmacyLocation,
  patientId,
  enterpriseOrderId,
  items,
  customerId,
  source,
});
